// HackHeaderTabs.js
import React from 'react'
import { Header } from './HackHeader'

const tabs = [
  { key: 'about',       label: 'About Us' },
  { key: 'problem',     label: 'Challenge' },
  { key: 'timeline',    label: 'Timeline' },
  { key: 'participate', label: 'How to Participate' },
  { key: 'evaluation',  label: 'Evaluation' },
  { key: 'resources',   label: 'Resources' },
  { key: 'faqs',        label: 'FAQs' }
]

export default function HeaderTabs() {
  return (
    <Header
      tabs={tabs}
      initialTab="about"
      registerHref="/register"
      onTabChange={tabKey => console.log('Active section:', tabKey)}
    />
  )
}
